import type { AssignExecutorToOrderRequest } from '@/core/generated/api';
import type { AssignExecutorFormValues } from './model/assignExecutorSchema';

/** Собирает запрос назначения исполнителя из заполненной формы */
export const assignExecutorFormToRequest = (
    values: AssignExecutorFormValues,
    orderId: string,
): AssignExecutorToOrderRequest => ({
    orderId,
    executorId: values.executorId,
    executorAddressId: values.executorAddressId || undefined,
    comment: values.comment.trim(),
});
